// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2xQbw{display:flex;justify-content:center}.UHjqxp{margin-top:50px}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadMoreContainer": `_2xQbw`,
	"loadMoreButton": `UHjqxp`
};
export default ___CSS_LOADER_EXPORT___;
